import { GetLotIdsQuery } from './lot_schemas'
import { generateContext } from '../../utils'
import { LotStationType, LotType, GetStationByParkingLotQuery, OccupancyByLotIdResponse } from './lot-types'
import { OccupancyConfigState } from '../Occupancy/hooks/useOccupancyConfig'
import { QueryObserverResult } from '@tanstack/react-query'
export interface ILotContext {
    selectedLot: LotType | null | undefined
    lots: GetLotIdsQuery | undefined
    setSelectedLot: (lot: LotType | null | undefined) => void
    lotStations: GetStationByParkingLotQuery | undefined
    setEditingStation: (station: LotStationType | undefined) => void
    editingStation: LotStationType | null | undefined
    occupancyConfig: OccupancyConfigState | undefined
    setOccupancyConfig: React.Dispatch<React.SetStateAction<OccupancyConfigState | undefined>>
    onHandleSubmit: () => void
    occupancyValue: OccupancyByLotIdResponse | undefined
    fetchOccupancyValue: () => void
    loading: boolean
    saving: boolean
    // The lot list has to land before a `?lot=` param can be resolved to a selection, so views need
    // to tell "still fetching" apart from "nothing selected" instead of reading both as empty.
    loadingLots: boolean
    loadingLotStations: boolean
    lastFetchOccupancy: Date | undefined
    refetchLotStations: () => Promise<QueryObserverResult<GetStationByParkingLotQuery, Error>>
    // occupancyTestUsers: boolean
}
const [LotContext, LotProvider] = generateContext<ILotContext>()
export { LotContext, LotProvider }
